import {nanoid} from 'nanoid';
import rollbar from '~/src/utilities/libs/rollbar';

let clientId: string;

const retrieveId = () => {
    try {
        return localStorage.getItem('clientId');
    } catch (error) {
        rollbar.info('Browser does not support LocalStorage API', error);
    }
};

const createId = () => {
    const id = nanoid();

    try {
        localStorage.setItem('clientId', id);
    } catch (error) {
        rollbar.info('Browser does not support LocalStorage API', error);
    }

    return id;
};

const getClientId = () => {
    if (!clientId) {
        clientId = retrieveId() || createId();
    }

    return clientId;
};

const isLegacyAppSession = () => window.navigator.userAgent.indexOf('native-20min') !== -1;

export {getClientId, isLegacyAppSession};
